/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Back_1Inputs */

const en_back_1 = /** @type {(inputs: Back_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Back`)
};

const es_back_1 = /** @type {(inputs: Back_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Atrás`)
};

const fr_back_1 = /** @type {(inputs: Back_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Retour`)
};

const de_back_1 = /** @type {(inputs: Back_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Zurück`)
};

const ja_back_1 = /** @type {(inputs: Back_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← 戻る`)
};

const zh_back_1 = /** @type {(inputs: Back_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← 返回`)
};

const ar_back_1 = /** @type {(inputs: Back_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← رجوع`)
};

const id_back_1 = /** @type {(inputs: Back_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Kembali`)
};

const it_back_1 = /** @type {(inputs: Back_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Indietro`)
};

const ru_back_1 = /** @type {(inputs: Back_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Назад`)
};

const pt_back_1 = /** @type {(inputs: Back_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Voltar`)
};

const ko_back_1 = /** @type {(inputs: Back_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← 뒤로`)
};

/**
* | output |
* | --- |
* | "← Back" |
*
* @param {Back_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const back_1 = /** @type {((inputs?: Back_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Back_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_back_1(inputs)
	if (locale === "es") return es_back_1(inputs)
	if (locale === "fr") return fr_back_1(inputs)
	if (locale === "de") return de_back_1(inputs)
	if (locale === "ja") return ja_back_1(inputs)
	if (locale === "zh") return zh_back_1(inputs)
	if (locale === "ar") return ar_back_1(inputs)
	if (locale === "id") return id_back_1(inputs)
	if (locale === "it") return it_back_1(inputs)
	if (locale === "ru") return ru_back_1(inputs)
	if (locale === "pt") return pt_back_1(inputs)
	return ko_back_1(inputs)
});